var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{ref:"dialog",attrs:{"title":_vm.title,"width":"1300px","in-dialog":_vm.inDialog},on:{"opened":_vm.onOpened}},[_c('list',{ref:"list"}),_c('template',{slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.submitmul}},[_vm._v("提交")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }